import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal';
import { AuthContext } from '../context/AuthContext';
import api from '../services/api';
import API_URL from '../config';
import './Register.css';

Modal.setAppElement('#root');

const Register = () => {
	const [civil, setCivil] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [Firstname, setFirstName] = useState('');
  const [address, setAddress] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [city, setCity] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [message, setMessage] = useState('');
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [showLabelsOnError, setShowLabelsOnError] = useState(false);
  const [acceptCgv, setAcceptCgv] = useState(false);
  const [isCgvModalOpen, setIsCgvModalOpen] = useState(false);
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const validateForm = () => {
    const newErrors = {};

    if (!civil) {
      newErrors.civil = 'Veuillez sélectionner une civilité.';
    }
    if (name.length < 3 || name.length > 30) {
      newErrors.name = 'Le nom doit contenir entre 3 et 30 caractères.';
    }
    if (Firstname.length < 2 || Firstname.length > 30) {
      newErrors.Firstname = 'Le prénom doit contenir entre 2 et 30 caractères.';
    }
    if (password.length < 6) {
      newErrors.password = 'Le mot de passe doit contenir au moins 6 caractères.';
    }
    if (!/^\d{5}$/.test(postalCode)) {
      newErrors.postalCode = 'Le code postal doit contenir exactement 5 chiffres.';
    }
    if (!/^\d{10}$/.test(mobileNumber)) {
      newErrors.mobileNumber = 'Le numéro de mobile doit contenir exactement 10 chiffres.';
    }
    if (!acceptCgv) {
      newErrors.cgv = 'Vous devez accepter les Conditions Générales de Vente.';
    }

    setErrors(newErrors);
    setShowLabelsOnError(Object.keys(newErrors).length > 0);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const response = await api.post(`${API_URL}/api/users/register`, {
        email,
        password,
		  civil,
        name,
        Firstname,
        address,
        postalCode,
        city,
        mobileNumber,
      });
      const { token } = response.data;
      login(token);
      setIsSuccessModalOpen(true);
    } catch (error) {
      if (error.response && error.response.data.message === "User already registered") {
        setMessage("L'adresse email est déjà utilisée. Veuillez en choisir une autre.");
      } else {
        setMessage("Erreur lors de la création du compte. Veuillez vérifier vos informations et réessayer.");
      }
    }
  };

  const goToLogin = () => {
    navigate('/login');
  };

  const handleSuccessModalClose = () => {
    setIsSuccessModalOpen(false);
    navigate('/');
  };

  const handleCgvModalOpen = () => {
    setIsCgvModalOpen(true);
  };

  const handleCgvModalClose = () => {
    setIsCgvModalOpen(false);
  };

  return (
    <div className="register-container">
      <form className="register-form" onSubmit={handleSubmit}>
        <h2>Créer un compte</h2>

        {showLabelsOnError && <label>Civilité</label>}
        <select
          value={civil}
          onChange={(e) => setCivil(e.target.value)}
          required
        >
          <option value="">Sélectionner votre civilité</option>
          <option value="man">M.</option>
          <option value="woman">Mme</option>
          <option value="lady">Mlle</option>
        </select>
        {errors.civil && <p className="error-message">{errors.civil}</p>}

        {showLabelsOnError && <label>Prénom</label>}
        <input
          type="text"
          placeholder="Prénom *"
          value={Firstname}
          onChange={(e) => setFirstName(e.target.value)}
          required
        />
        {errors.Firstname && <p className="error-message">{errors.Firstname}</p>}

        {showLabelsOnError && <label>Nom</label>}
        <input
          type="text"
          placeholder="Nom *"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        {errors.name && <p className="error-message">{errors.name}</p>}

        {showLabelsOnError && <label>Email</label>}
        <input
          type="email"
          placeholder="Email *"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        {errors.email && <p className="error-message">{errors.email}</p>}

        {showLabelsOnError && <label>Adresse</label>}
        <input
          type="text"
          placeholder="Adresse *"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          required
        />
        {errors.address && <p className="error-message">{errors.address}</p>}

        {showLabelsOnError && <label>Code Postal</label>}
        <input
          type="text"
          placeholder="Code Postal *"
          value={postalCode}
          onChange={(e) => setPostalCode(e.target.value)}
          required
        />
        {errors.postalCode && <p className="error-message">{errors.postalCode}</p>}

        {showLabelsOnError && <label>Ville</label>}
        <input
          type="text"
          placeholder="Ville *"
          value={city}
          onChange={(e) => setCity(e.target.value)}
          required
        />
        {errors.city && <p className="error-message">{errors.city}</p>}

        {showLabelsOnError && <label>Numéro de mobile</label>}
        <input
          type="tel"
          placeholder="Numéro de mobile *"
          value={mobileNumber}
          onChange={(e) => setMobileNumber(e.target.value)}
          required
        />
        {errors.mobileNumber && <p className="error-message">{errors.mobileNumber}</p>}

        {showLabelsOnError && <label>Mot de passe</label>}
        <input
          type="password"
          placeholder="Mot de passe (minimum 6 caractères)"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        {errors.password && <p className="error-message">{errors.password}</p>}

        {/* Checkbox for CGV */}
  <div className="cgv-checkbox-container">
    <span>
      J'ai lu et j'accepte les 
      <span
        onClick={handleCgvModalOpen}
        style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline', marginLeft: '5px' }}
      >
        Conditions Générales de Vente
      </span>
    </span>
    <input
      type="checkbox"
      checked={acceptCgv}
      onChange={() => setAcceptCgv(!acceptCgv)}
      style={{ marginLeft: '8px' }} /* Ajustez l'espace entre le texte et la case */
    />
  </div>

        <button type="submit">S'inscrire</button>

        {message && <p className="error-message">{message}</p>}
      </form>

      {/* Modal for success */}
      <Modal
        isOpen={isSuccessModalOpen}
        onRequestClose={handleSuccessModalClose}
        className="success-modal"
        overlayClassName="overlay"
      >
        <h3>Compte créé avec succès !</h3>
        <p>Votre compte avec l'adresse email {email} a été créé.</p>
        <button className="home-button" onClick={handleSuccessModalClose}>OK</button>
      </Modal>

      {/* Modal for CGV */}
      <Modal
        isOpen={isCgvModalOpen}
        onRequestClose={handleCgvModalClose}
        className="cgv-modal"
        overlayClassName="modal-overlay"
      >
        <h3>Conditions Générales de Vente</h3>
        <div style={{ backgroundColor: 'white', padding: '10px', maxHeight: '400px', overflowY: 'scroll', textAlign: 'left' }}>
		<p>1. Objet</p>
		<p>Les présentes Conditions Générales de Vente (CGV) définissent les modalités de réservation, de paiement et d’utilisation des salles de location proposées par ECOLE JEAN FASSINA, société par actions simplifiée dont le siège social est situé 109 boulevard Beaumarchais 75003 Paris, immatriculée sous le SIREN 882348295.</p>
		<p>En accédant et en utilisant notre service de location de salles via notre site internet https://piano.ted.paris, l’utilisateur accepte pleinement et sans réserve les présentes CGV.</p>

		<p>2. Description des services</p>
		<p>ECOLE JEAN FASSINA propose la location de salles pour diverses activités, notamment :</p>
		<ul>
		  <li>Grande salle : équipée d’un piano Steinway pour des sessions en solo ou en groupe.</li>
		  <li>Petite salle : équipée d’un piano droit pour des sessions en solo.</li>
		</ul>
		<p>Les salles sont accessibles pour des créneaux horaires définis et peuvent être réservées en ligne via notre site.</p>

		<p>3. Réservation</p>
		<ul>
		  <li>Les réservations s’effectuent exclusivement en ligne, sous réserve de disponibilité, et sont validées dès réception du paiement intégral.</li>
		  <li>Une fois la réservation confirmée, un code de réservation sera fourni au client. Ce code sera à fournir afin de pouvoir prendre possession de la salle. Le code est donné sur le site (immédiatement suite au paiement, ou ultérieurement dans la section "Réservations"). Il est également envoyé à l’adresse e-mail fournie par le client lors de son inscription.</li>
		  <li>La réservation est nominative et ne peut être cédée sans l’accord de ECOLE JEAN FASSINA.</li>
		</ul>

		<p>4. Tarifs et modalités de paiement</p>
		<ul>
		  <li>Les tarifs des salles sont indiqués en euros, toutes taxes comprises (TTC).</li>
		  <li>Le paiement s’effectue en ligne via notre partenaire de paiement sécurisé Stripe.</li>
		  <li>ECOLE JEAN FASSINA se réserve le droit de modifier les tarifs à tout moment. Les tarifs appliqués seront ceux en vigueur au moment de la réservation.</li>
		</ul>

		<p>5. Droit de rétractation</p>
		<p>Conformément à l’article L221-28 du Code de la consommation, le droit de rétractation de 14 jours ne s’applique pas aux services de location de salles ou d’hébergement à une date ou période déterminée. Ainsi, une fois la réservation confirmée, elle est définitive et non remboursable, sauf dans les conditions précisées ci-après.</p>

		<p>6. Conditions d’annulation et de remboursement</p>
		<ul>
		  <li>Annulation par le client : les réservations payées ne sont pas intégralement remboursables (sauf cas de force majeure justifié). Les réservations annulées jusqu'à 7 jours avant la date prévue sont remboursables à 75%, celles annulées jusqu'à 3 jours sont remboursables à 50%, celles annulées jusqu'à 1 jour sont remboursables à 25%. Passé ce délai, aucun remboursement ne sera effectué.</li>
		  <li>Annulation par ECOLE JEAN FASSINA : En cas d’imprévu, ECOLE JEAN FASSINA se réserve le droit d’annuler une réservation. Dans ce cas, le client sera intégralement remboursé sans possibilité de réclamer des dommages et intérêts.</li>
		</ul>

		<p>7. Utilisation des salles</p>
		<ul>
		  <li>Le client s’engage à utiliser la salle de manière respectueuse et à ne pas endommager les équipements mis à disposition.</li>
		  <li>Il est strictement interdit de fumer, de consommer de l’alcool ou de se comporter de manière inappropriée dans les salles.</li>
		  <li>L’utilisation des salles est limitée aux horaires réservés. Toute prolongation non autorisée pourra faire l’objet d’une facturation supplémentaire.</li>
		  <li>En cas de dégradations ou de pertes de matériel, le client sera tenu responsable et devra rembourser les frais de remise en état ou de remplacement.</li>
		</ul>

		<p>8. Responsabilités et assurances</p>
		<ul>
		  <li>ECOLE JEAN FASSINA décline toute responsabilité en cas de perte, de vol ou de détérioration des effets personnels dans les salles.</li>
		  <li>Le client est responsable des dommages causés aux biens et équipements de ECOLE JEAN FASSINA pendant la durée de la location. Il est recommandé de souscrire une assurance couvrant les dommages matériels et corporels.</li>
		  <li>En cas d’accident ou de blessure survenu dans les locaux, la responsabilité de ECOLE JEAN FASSINA ne pourra être engagée, sauf en cas de négligence prouvée.</li>
		</ul>

		<p>9. Protection des données personnelles</p>
		<p>Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, ECOLE JEAN FASSINA collecte et traite les données personnelles des utilisateurs pour la gestion des réservations et la relation client.</p>
		<ul>
		  <li>Finalité : Les données collectées sont utilisées uniquement pour traiter les réservations et assurer la communication avec les clients.</li>
		  <li>Durée de conservation : Les données sont conservées pendant la durée nécessaire à la gestion de la relation client et pour respecter les obligations légales.</li>
		  <li>Droits des utilisateurs : Le client dispose d’un droit d’accès, de rectification, d’effacement et d’opposition sur ses données personnelles, qu’il peut exercer en contactant notre délégué à la protection des données (DPO) à l’adresse suivante : contact@ecolejeanfassina.com</li>
		  <li>Transmission des données : Les données ne seront pas partagées avec des tiers sans consentement préalable, sauf obligation légale.</li>
		</ul>

		<p>10. Modification des CGV</p>
		<p>ECOLE JEAN FASSIN se réserve le droit de modifier les présentes CGV à tout moment. Les nouvelles versions des CGV seront disponibles sur le site internet et s’appliqueront immédiatement aux nouvelles réservations. Les clients seront informés de toute modification substantielle.</p>

		<p>12. Loi applicable et juridiction compétente</p>
		<p>Les présentes CGV sont soumises au droit français. En cas de litige et à défaut de résolution amiable, le tribunal compétent sera celui de Paris.</p>
        </div>
        <button onClick={handleCgvModalClose} className="home-button">Fermer</button>
      </Modal>
    </div>
  );
};

export default Register;